var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var valid = ref.valid;
var invalid = ref.invalid;
var passed = ref.passed;
return [_c('v-text-field',{attrs:{"id":_vm.id,"type":_vm.type,"placeholder":_vm.placeholder,"value":_vm.value,"disabled":_vm.disabled,"label":_vm.label,"error":errors.length > 0,"error-messages":errors,"required":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }